import axios from 'axios';

export default function getMyActivity(params, config) {
    const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
        Authorization: `Bearer ${localStorage.getItem('jwtToken')}`,
        'x-location-id': localStorage.getItem('locationId')
    };

    const queryString = Object
      .keys(params)
      .filter(key => params[key])
      .map((key) => {
            if (key === 'lastEvaluatedKey') {
              return `${key}=${params[key]['sortKey']}`;
            }
            return `${key}=${params[key]}`;
        })
      .join('&');

    const url = `${config.getSearchMyActivity}?${queryString}`;

    return dispatch => dispatch({
        type: 'MY_ACTIVITY_FETCH',
        payload: axios({ method: 'get', url, headers })
    });
}


// WEBPACK FOOTER //
// ./src/actions/getMyActivity.js